import React from 'react';
import PageHeader from '../../components/Layout/PageHeader/PageHeader';
import NotificationsArchive from './../../components/Notifications/NotificationsArchive/NotificationsArchive';
import { useTranslation } from 'react-i18next';

function Notifications() {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <PageHeader
                title={t('notifications.header')}
                subtitle={t('notifications.browse_notifications')}
            />
            <div className="container">
                <NotificationsArchive />
            </div>
        </React.Fragment>
    );
}

export default Notifications;